// InspectionStep.jsx
import React, { useState, useEffect } from 'react';
// import inspectionConfig from './inspectionConfig';
import getInspectionConfig from './inspectionConfig';
// import { useNextSteps } from '../../contexts/NextStepsContext';
import { useNextSteps } from '../NextStepsContext';
import TaskItem from '../TaskItem';
import SubTaskItem from '../SubTaskItem';
import UploadModal from '../../DocumentUpload/UploadModal';
import InspectionObjectionModal from './InspectionObjectionModal';
import InspectionObjectionPacketSign from '../../PacketSigning/InspectionObjectionPacketSign';
import InspectionObjectionWithdrawalModal from './InspectionObjectionWithdrawalModal';
import InspectionObjectionWithdrawalSign from '../../PacketSigning/InspectionObjectionWithdrawalSign';
import InspectionResolutionModal from './InspectionResolutionModal'; 
import InspectionResolutionSign from '../../PacketSigning/InsepctionResolutionSign';
import TerminationModal from '../TerminationModal';
import TerminationPacketSign from '../../PacketSigning/TerminationSign';
import LatestUpload from '../LatestUpload';
import PdfAnalyzerAgent from '../../PDFAnalyzer/PdfAnalyzerAgent';
import Modal from '../../Modal'; 
import '../Task.css';

const InspectionStep = ({ contract, due, expandedSteps }) => {
  const { nextStepsState, updateNextStep, toggleMainStepCompletion, persistNextStepsState, calculateMainState } = useNextSteps();
  const [expanded, setExpanded] = React.useState(false);
  const [showUploadModal, setShowUploadModal] = React.useState(false);
  const [showObjectionModal, setShowObjectionModal] = React.useState(false);
  const [showWithdrawalModal, setShowWithdrawalModal] = React.useState(false);
  const [showResolutionModal, setShowResolutionModal] = React.useState(true);
  const [showTerminationModal, setShowTerminationModal] = React.useState(false);
  const [objectionData, setObjectionData] = React.useState(null);
  const [terminationData, setTerminationData] = React.useState(null);
  const [isWithdrawal, setIsWithdrawal] = useState(false);
  const [withdrawalData, setWithdrawalData] = React.useState(null);
  const [resolutionData, setResolutionData] = React.useState(null);
  const [uploadRefresh, setUploadRefresh] = React.useState(0);
  const [currentSubAction, setCurrentSubAction] = useState(null);
  const [showAnalyzer, setShowAnalyzer] = useState(false);
  const [analysisFileUrl, setAnalysisFileUrl] = useState(null);
  const formType = 'inspection';
  const inspectionObjectionPacket = contract?.additionalPackets?.filter(packet => packet.formType === 'Inspection Objection')[0]; 
  const inspectionConfig = getInspectionConfig(contract);

  // Example function for toggling a sub-step's completion
  const toggleSubStep = (subTaskKey) => {
    updateNextStep(inspectionConfig.taskKey, { 
      completed: !nextStepsState.inspection.subSteps[subTaskKey].completed 
    }, subTaskKey);
  };

  const handleSubStepAction = (actionText, taskKey) => {
    // Based on the taskKey you can decide what to do.
    setCurrentSubAction(actionText);
    if (taskKey === 'uploadReport') {
      setShowUploadModal(true);
    } 
    else if (taskKey === 'analyzeReport' && actionText === 'Analyze') {
      setShowAnalyzer(true);
    }    
    else if (taskKey === 'generateInspectionObjection') {
      setObjectionData(null);
      setShowObjectionModal(true);
    }
    else if (taskKey === 'postInspectionObjection' && actionText === 'Resolve') {
      setResolutionData(null);
      setShowResolutionModal(true);
    }
    else if (taskKey === 'postInspectionObjection' && actionText === 'Withdraw') {
      setWithdrawalData(null);
      setShowWithdrawalModal(true);
    }
    else if (taskKey === 'postInspectionObjection' && actionText === 'Terminate') {
      setTerminationData(null);
      setShowTerminationModal(true);
    }
  };
  
  return (
    <div className="inspection-step">
      <div
        onClick={() => setExpanded(!expanded)}
        className={`task-container ${expanded ? 'expanded rounded-b-none mt-1' : 'my-1'} shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]`}
      >
        <TaskItem
          number="3"
          title={inspectionConfig.title}
          description={inspectionConfig.subText}
          due={due}
          subTaskKey={null}
          taskKey={inspectionConfig.taskKey}
          onCardClick={() => setExpanded(!expanded)} 
          isExpanded={expanded}
          nextStepsState={nextStepsState}
          toggleCompletion={toggleMainStepCompletion}
        />
      </div>
      {expanded && (
        <div className={`drawer ${expanded ? 'expanded' : ''} ${expanded ? 'shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] rounded-b-lg mb-1': ''}`}>
          {inspectionConfig.subSteps.map((subStep, index) => (
            <div key={index}>
                    <SubTaskItem
                      number={`3.${index + 1}`}
                      stepType='inspection'
                      title={subStep.title}
                      subText={subStep.subText}
                      onToggle={() => toggleSubStep(subStep.taskKey)}
                      actionTexts={subStep.actionTexts}
                      // onToggle={() => setShowObjectionModal(true)}
                      onAction={(actionText) => 
                          handleSubStepAction(actionText, subStep.taskKey)
                        }
                      isCompleted={
                        nextStepsState.inspection.subSteps[subStep.taskKey]?.completed
                      }
                      decision={nextStepsState.inspection.subSteps[subStep.taskKey]?.decision}
                      isSchedule={nextStepsState.inspection.subSteps[subStep.taskKey]?.scheduleDate}
                      scheduleDate={nextStepsState.inspection.subSteps[subStep.taskKey]?.scheduleDate}
                      onScheduleChange={(newDate) =>
                        updateNextStep("inspection", { scheduleDate: newDate }, "scheduleInspector")
                      }
                    />
              {subStep.type === 'upload' ? (
                <>
                <div className='flex-col gap-2 w-full justify-end'>
                  <LatestUpload
                    formType="inspection"
                    refresh={uploadRefresh}
                    onLatestUploadUpdate={(url) => setAnalysisFileUrl(url)}
                    onDeleteSuccess={() => {
                        // When no inspection file remains, update the NextSteps state for uploadReport to false.
                        updateNextStep('inspection', { 
                        subSteps: {
                            ...nextStepsState.inspection.subSteps,
                            uploadReport: { completed: false, uploadedAt: null },
                        },
                        state: calculateMainState({
                            ...nextStepsState.inspection.subSteps,
                            uploadReport: { completed: false, uploadedAt: null },
                        }),
                        });
                    }}
                    />
                  </div>
                  <UploadModal
                    isOpen={showUploadModal}
                    onClose={() => setShowUploadModal(false)}
                    isCompleted={nextStepsState.inspection.subSteps[subStep.taskKey]?.completed}
                    formType={formType}
                    onUploadSuccess={(data) => {
                      if (data.url) {
                        const updatedUploadReport = {
                          completed: true,
                          uploadedAt: new Date(),
                        };
                        updateNextStep('inspection', { 
                          subSteps: {
                            ...nextStepsState.inspection.subSteps,
                            uploadReport: updatedUploadReport,
                          },
                          state: calculateMainState({
                            ...nextStepsState.inspection.subSteps,
                            uploadReport: updatedUploadReport,
                          }),
                        });
                        // Force LatestUpload to re-fetch by updating the refresh counter:
                        setUploadRefresh(prev => prev + 1);
                      } else {
                        updateNextStep('inspection', { 
                          subSteps: {
                            ...nextStepsState.inspection.subSteps,
                            uploadReport: { completed: false, uploadedAt: null },
                          },
                          state: calculateMainState(nextStepsState.inspection.subSteps),
                        });
                      }
                      setShowUploadModal(false);
                    }}
                  />
                </> 
                ) : subStep.taskKey === 'analyzeReport' ? (
                <>
                  {showAnalyzer && analysisFileUrl && (
                    <Modal onClose={() => setShowAnalyzer(false)}>
                      <PdfAnalyzerAgent
                        fileUrl={analysisFileUrl}
                        fileName="InspectionReport.pdf"
                      />
                    </Modal>
                  )}
                </>
      ) : subStep.taskKey === 'generateInspectionObjection' ? (
                <>
                  <InspectionObjectionModal
                    key={objectionData ? objectionData.objectionText : 'empty'}
                    isOpen={showObjectionModal}
                    onClose={() => {
                        setShowObjectionModal(false);
                        setObjectionData(null); // Clear the objection data when closing
                      }}
                    address={contract.data.address.street}
                    contract={contract}
                    onSubmit={(objectionText, contractData) => {
                      setObjectionData({ objectionText, contract: contractData });
                      setShowObjectionModal(false);
                      // Trigger signature process as needed…
                    }}
                  />
                    {objectionData && (
                        <InspectionObjectionPacketSign
                        contract={objectionData.contract}
                        objectionText={objectionData.objectionText}
                        isCompleted={nextStepsState.inspection.subSteps[subStep.taskKey]?.completed}
                        onInspectionSuccess={(data) => {
                            const updatedSubStep = {
                              completed: true,
                              completedAt: new Date(),
                            };
                            const newMainState = calculateMainState({
                              ...nextStepsState.inspection.subSteps,
                              generateInspectionObjection: updatedSubStep,
                            });
                            // Update the inspection task using your context helper.
                            updateNextStep('inspection', {
                              subSteps: {
                                ...nextStepsState.inspection.subSteps,
                                generateInspectionObjection: updatedSubStep,
                              },
                              state: newMainState,
                            });
                          }}
                          
                        />
                    )}
                        {/* <>
                            {inspectionObjectionPacket?.packetDetails?.documentGroup?.files?.[0]?.downloadURL ? (
                            <div className='flex justify-end'>
                                <a href={inspectionObjectionPacket.packetDetails.documentGroup.files[0].downloadURL} target="_blank" rel="noopener noreferrer" className='text-blue-500 underline text-[12px]'>Inspection Objection</a>
                            </div>
                            ) : (
                            <div className='flex justify-end'>
                                <p className='text-shi-green text-[12px]'>Inspection Objection</p>
                            </div>
                            )}
                        </> */}
                </>
              ) : subStep.taskKey === 'postInspectionObjection' && currentSubAction === 'Withdraw' ? (
                  <>
                    {/* <SubTaskItem
                      number={`3.${index + 1}`}
                      title={subStep.title}
                      subText={subStep.subText}
                      actionTexts={subStep.actionTexts}
                      // onToggle={() => setShowObjectionModal(true)}
                      onAction={(actionText) => 
                          handleSubStepAction(actionText, subStep.taskKey)
                        }
                      isCompleted={
                        nextStepsState.inspection.subSteps[subStep.taskKey]?.completed
                      }
                      decision={nextStepsState.inspection.subSteps[subStep.taskKey]?.decision}
                    /> */}
                      <InspectionObjectionWithdrawalModal
                        isOpen={showWithdrawalModal}
                        onClose={() => {
                          setShowWithdrawalModal(false);
                          setWithdrawalData(null);
                        }}
                        address={contract.data.address.street}
                        contract={contract}
                        onSubmit={(contractData) => {
                          setWithdrawalData({ contract: contractData });
                          setShowWithdrawalModal(false);
                          setIsWithdrawal(true); 
                          // Trigger any further actions if needed…
                        }}
                      />
                      {isWithdrawal && withdrawalData && withdrawalData.contract && (
                          <InspectionObjectionWithdrawalSign
                          contract={withdrawalData.contract}
                          // objectionText={objectionData.objectionText}
                          isCompleted={nextStepsState.inspection.subSteps[subStep.taskKey]?.completed}
                          onInspectionSuccess={(data) => {
                              const updatedSubStep = {
                                completed: true,
                                decision: "Withdraw",
                              };
                              const newMainState = calculateMainState({
                                ...nextStepsState.inspection.subSteps,
                                postInspectionObjection: updatedSubStep,
                              });
                              // Update the inspection task using your context helper.
                              updateNextStep('inspection', {
                                subSteps: {
                                  ...nextStepsState.inspection.subSteps,
                                  postInspectionObjection: updatedSubStep,
                                },
                                state: newMainState,
                              });
                            }}
                          />
                        )}
                  </>
                    ) : subStep.taskKey === 'postInspectionObjection' && currentSubAction === 'Resolve' ? (
                      <>
                        {/* <SubTaskItem
                          number={`3.${index + 1}`}
                          title={subStep.title}
                          subText={subStep.subText}
                          actionTexts={subStep.actionTexts}
                          // onToggle={() => setShowObjectionModal(true)}
                          onAction={(actionText) => 
                              handleSubStepAction(actionText, subStep.taskKey)
                            }
                          isCompleted={
                            nextStepsState.inspection.subSteps[subStep.taskKey]?.completed
                          }
                        /> */}
                          <InspectionResolutionModal
                            key={showResolutionModal ? 'open' : 'closed'}
                            isOpen={showResolutionModal}
                            onClose={() => {
                              setShowResolutionModal(false);
                              setResolutionData(null);
                            }}
                            address={contract.data.address.street}
                            contract={contract}
                            onSubmit={(resolutionText, contractData) => {
                              setResolutionData({ resolutionText, contract: contractData });
                              setShowResolutionModal(false);
                              console.log("Handling Resolve action");
                            }}
                          />
                        {resolutionData && (
                            <InspectionResolutionSign
                            contract={resolutionData.contract}
                            resolutionText={resolutionData.resolutionText}
                            isCompleted={nextStepsState.inspection.subSteps[subStep.taskKey]?.completed}
                            onInspectionSuccess={(data) => {
                                const updatedSubStep = {
                                  completed: true,
                                  decision: "Resolution",
                                };
                                const newMainState = calculateMainState({
                                  ...nextStepsState.inspection.subSteps,
                                  postInspectionObjection: updatedSubStep,
                                });
                                // Update the inspection task using your context helper.
                                updateNextStep('inspection', {
                                  subSteps: {
                                    ...nextStepsState.inspection.subSteps,
                                    postInspectionObjection: updatedSubStep,
                                  },
                                  state: newMainState,
                                });
                              }}
                            />
                          )}
                    </>
                      ) : subStep.taskKey === 'postInspectionObjection' && currentSubAction === 'Terminate' ? (
                        <>
                            <TerminationModal
                              key={showTerminationModal ? 'open' : 'closed'}
                              isOpen={showTerminationModal}
                              onClose={() => {
                                setShowTerminationModal(false);
                                setTerminationData(null);
                              }}
                              address={contract.data.address.street}
                              contract={contract}
                              onSubmit={(terminationData, contractData) => {
                                setTerminationData({ terminationData, contract: contractData });
                                setShowTerminationModal(false);
                                console.log("Handling Termination action");
                              }}
                            />
                          {terminationData && (
                              <TerminationPacketSign
                              contract={terminationData.contract}
                              terminationType={terminationData.terminationData}
                              isCompleted={nextStepsState.inspection.subSteps[subStep.taskKey]?.completed}
                              onInspectionSuccess={(data) => {
                                  const updatedSubStep = {
                                    completed: true,
                                    decision: "Termination",
                                  };
                                  const newMainState = calculateMainState({
                                    ...nextStepsState.inspection.subSteps,
                                    postInspectionObjection: updatedSubStep,
                                  });
                                  // Update the inspection task using your context helper.
                                  updateNextStep('inspection', {
                                    subSteps: {
                                      ...nextStepsState.inspection.subSteps,
                                      postInspectionObjection: updatedSubStep,
                                    },
                                    state: newMainState,
                                  });
                                }}
                              />
                            )}
                      </>
                      ) : 
                    <React.Fragment></React.Fragment>
              //       (
              //   <SubTaskItem
              //     number={`3.${index + 1}`}
              //     title={subStep.title}
              //     subText={subStep.subText}
              //     actionTexts={subStep.actionTexts}
              //     onToggle={() => toggleSubStep(subStep.taskKey)}
              //     isSchedule={nextStepsState.inspection.subSteps[subStep.taskKey]?.scheduleDate}
              //     scheduleDate={nextStepsState.inspection.subSteps[subStep.taskKey]?.scheduleDate}
              //     onScheduleChange={(newDate) =>
              //       updateNextStep("inspection", { scheduleDate: newDate }, "scheduleInspector")
              //     }
              //     isCompleted={
              //       nextStepsState.inspection.subSteps[subStep.taskKey]?.completed
              //     }
              //   />
              // )
              }
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InspectionStep;